export type InvalidFieldNavigationOptions = {
  fieldName: string;
  rootElement?: ParentNode;
  querySelector?: string;
  highlightDurationMs?: number;
  highlightClassName?: string;
};

const DEFAULT_QUERY_SELECTOR = '[formcontrolname="{fieldName}"]';
const DEFAULT_HIGHLIGHT_DURATION_MS = 1800;
const DEFAULT_HIGHLIGHT_CLASS_NAME = 'invalid-target-highlight';

export function navigateToInvalidField(options: InvalidFieldNavigationOptions): void {
  const {
    fieldName,
    rootElement,
    querySelector = DEFAULT_QUERY_SELECTOR,
    highlightDurationMs = DEFAULT_HIGHLIGHT_DURATION_MS,
    highlightClassName = DEFAULT_HIGHLIGHT_CLASS_NAME
  } = options;

  const queryRoot = rootElement ?? document;
  const selector = querySelector.replace('{fieldName}', fieldName);
  const element = queryRoot.querySelector(selector) as HTMLElement | null;
  if (!element) {
    return;
  }

  highlightAndFocus(element, highlightClassName, highlightDurationMs);
}

function highlightAndFocus(element: HTMLElement, highlightClassName: string, highlightDurationMs: number): void {
  element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  element.classList.add(highlightClassName);

  if (typeof element.focus === 'function') {
    element.focus({ preventScroll: true });
  }

  setTimeout(() => {
    element.classList.remove(highlightClassName);
  }, highlightDurationMs);
}
